export default {
  namespaced: true,
  state: {
    needsReRender: false
  },
  mutations: {
    setNeedsReRender(state, payload) {
      state.needsReRender = payload;
    }
  },
  actions: {
    triggerReRender({ commit }) {
      commit('setNeedsReRender', true);
    }
  },
  getters: {
    getNeedsReRender(state) {
      return state.needsReRender;
    }
  }
}
